














import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { Product } from '~/modules/catalog/product/types';
import { useProductStore } from '~/modules/catalog/stores/product';
import LinkWithArrow from '~/components/General/LinkWithArrow.vue';
import {
  getProductAssembledLength,
  getProductAssembledWidth,
  getProductAssembledHeight,
} from '~/modules/catalog/product/getters/productGetters';

export default defineComponent({
  components: {
    LinkWithArrow,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup(props) {
    const productStore = useProductStore();

    const showDimensions = computed(() => getProductAssembledLength(props.product)
      || getProductAssembledWidth(props.product)
      || getProductAssembledHeight(props.product));

    const openTab = () => {
      productStore.openTab('dimensions');
      document.querySelector('#dimensions').scrollIntoView({ behavior: 'smooth' });
    };

    return {
      showDimensions,
      getProductAssembledLength,
      getProductAssembledWidth,
      getProductAssembledHeight,
      openTab,
    };
  },
});
